import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Accordion from "../../components/Accordion";
import PosgradoPagos from "../../components/PosgradoPagos";
import { PosgradoPostulacionFixed, NormativaPosgrados} from "../../components/Pasos";
import ConectUs from "../../components/ConectUs";
import BlockLeftImage from "../../components/BlockLeftImage";
import Quote from "../../components/Quote";
import Block6Columns from "../../components/Block6Columns";
import calendario from "../../img/iconsoferta/calendario.png";
import Block3Columns from "../../components/Block3Columns";
import modalidad from "../../img/iconsoferta/modalidad.png";
import titulo from "../../img/iconsoferta/titulo.png";
import sale from "../../img/iconsoferta/sale.png";
import campo from "../../img/iconsoferta/campo.png";
import inicio from "../../img/iconsoferta/inicio.png";

function MaestriaContenidosIA() {
  function brochure(data) {
    // Si data es un array, tomamos el primer elemento; si es un string, lo usamos directamente
    const url = Array.isArray(data) ? data[0] : data;

    // Validar que url es un string y que no está vacío
    if (typeof url !== "string" || !url.trim()) {
      return null;
    }

    return (
      <>
        <a className="button" target="_blank" rel="noreferrer" href={url}>
          Brochure del programa 📕
        </a>
        <br />
      </>
    );
  }

  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            {" "}
            <BlockImageCabecera
              src={item.field_portada}
              title={
                    <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                  {item.field_oferta_actual === "1" && (
                    <>
                      <PosgradoPostulacionFixed />
                        <a href={item.field_enlace_postulacion}>
                            Postula ahora
                          </a>
                    </>
                  )}
                </>
              }
            ></BlockImageCabecera>
            <div className="graybg">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/posgrados">Posgrados</NavLink>
                    <span class="material-icons">chevron_right</span>
                    <NavLink to="/maestria-comunicacion-ia">
                      Maestría en Comunicación, Ideación y Creación de
                      Contenidos con Inteligencia Artificial{" "}
                    </NavLink>
                  </>
                }
              ></Breadcumbs>
              <div className="padding oferta-icons">
                <Block6Columns
                  col1={
                    <>
                      <img src={titulo}></img>
                      <p>
                        <b>Título</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_posgrado_titulo,
                        }}
                      />
                    </>
                  }
                  col2={
                    <>
                      <img src={modalidad}></img>
                      <p>
                        <b>Modalidad</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_modalidad,
                        }}
                      />
                    </>
                  }
                  col3={
                    <>
                      <img src={calendario}></img>
                      <p>
                        <b>Duración</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_posgrado_duracion,
                        }}
                      />
                    </>
                  }
                  col4={
                    <>
                      <img src={campo}></img>
                      <p>
                        <b>Campo amplio</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_posgrado_campo,
                        }}
                      />
                    </>
                  }
                  col5={
                    <>
                      <img src={sale}></img>
                      <p>
                        <b>Precio</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_precio,
                        }}
                      />
                    </>
                  }
                  col6={
                    <>
                      <img src={inicio}></img>
                      <p>
                        <b>Fecha de inicio</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_inicio,
                        }}
                      />
                    </>
                  }
                ></Block6Columns>
              </div>
            </div>
            <div className=" margin ">
              <div className="relative">
                <div className="layout8 "> {brochure(item.field_brochure)}</div>
                <div
                  className="layout8"
                  dangerouslySetInnerHTML={{
                    __html: item.field_pos_resolucion,
                  }}
                />{" "}
              </div>
              <div
                className="layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_posgrado_ingreso,
                }}
              />{" "}
            </div>
            <Quote
              content={
                <>
                  {" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_atributo,
                    }}
                  />
                </>
              }
            ></Quote>
            <div
              className="section-perfil-egreso"
              style={{
                backgroundImage: `url(${item.field_posgrado_imagenegreso})`,
              }}
            ></div>
            <div
              className="layout8 padding"
              dangerouslySetInnerHTML={{
                __html: item.field_posgrado_egreso,
              }}
            />
            <div className="layout6 ">
              {" "}
              <Accordion
                title="Malla curricular"
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_posgrado_malla,
                      }}
                    />{" "}
                  </>
                }
              ></Accordion>
            </div>
            <Quote
              content={
                <>
                  {" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_atributo2,
                    }}
                  />
                </>
              }
            ></Quote>{" "}
            <div className=" relative ">
              <div>
                <BlockLeftImage
                  src={item.field_imagen_requisitos}
                  content={
                    <>
                      {" "}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_posgrado_requisitos,
                        }}
                      />
                      {item.field_oferta_actual === "1" && (
                        <>
                          <PosgradoPostulacionFixed />
                            <a href={item.field_enlace_postulacion}>
                            Postula ahora
                          </a>
                        </>
                      )}
                      <NormativaPosgrados></NormativaPosgrados>
                    </>
                  }
                ></BlockLeftImage>{" "}
              </div>
            </div>
              {item.field_oferta_actual === "1" && (
              <>
                <div className="padding">
                  <PosgradoPagos></PosgradoPagos>
                </div>
              </>
            )}
            <div
              className="diferencia  "
              style={{
                backgroundImage: `url(${item.field_posgrado_imagenegreso})`,
              }}
            >
              <div className="bluebg padding">
                <div className="layout8">
                  <center>
                    {" "}
                    <h2>
                      ¿Qué <b>nos diferencia?</b>
                    </h2>
                  </center>
                </div>

                <Block3Columns
                  col1={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_posgrado_diferencia,
                      }}
                    />
                  }
                  col2={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_posgrado_diferencia2,
                      }}
                    />
                  }
                  col3={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_posgrado_diferencia3,
                      }}
                    />
                  }
                ></Block3Columns>
                <br></br>
              </div>
            </div>
            <div className="wrapper-docente  margin">
              <div
                className="layout6"
                dangerouslySetInnerHTML={{
                  __html: item.field_texto_docente,
                }}
              />

              <div
                className="flex-center"
                dangerouslySetInnerHTML={{
                  __html: item.field_docente,
                }}
              />
            </div>
          </div>
        ))}{" "}
        <Quote
          content={
            <p>
              Implementamos adaptaciones curriculares no significativas, como
              ajustes en tiempos de entrega y recursos, con el fin de garantizar
              el cumplimiento de los objetivos de aprendizaje. Estas
              adaptaciones pueden aplicarse tanto a estudiantes con discapacidad
              como a aquellos que no presentan dicha condición.
            </p>
          }
        ></Quote>
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://www.utpl.edu.ec/maestrias/services/maestria-contenidosia.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <ConectUs
        lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes de posgrado."
        instagram="https://www.instagram.com/utplposgrados/"
        facebook="https://www.facebook.com/utplposgrados"
      ></ConectUs>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default MaestriaContenidosIA;
